import Nav from "./Components/Nav";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from "./Pages/Home";


import { Footer } from "./Pages/Footer";
import { AboutUs, Download, Features, Privacy, Safety, Terms } from "./Pages";



function App() {
  return (
     <div className="font-Poppins">
    
        <Nav/>
        <Routes>
          <Route path='/' element={ <Home/>} />
           <Route path='/about-us' element={<AboutUs/>} />
            <Route path='/features' element={<Features/>} />
         <Route path='/safety' element={<Safety/>} />
         <Route path='/privacy' element={<Privacy/>} />
          <Route path='/terms' element={<Terms/>} />   
         </Routes>
         <Download/>
         <Footer/>
        
       
    </div>
  );
}

export default App;
